import ImageWrapper from "@/components/ImageWrapper";

const formats = [
  "xxsmall",
  "xsmall",
  "thumbnail",
  "small",
  "medium",
  "large",
  "xlarge",
  "xxlarge",
];

const hasDimension = ({ width, height }) => {
  return !!width && !!height;
};

export default function ResponsiveImage({
  file,
  className,
  alt,
  component: Component = "div",
  asBackground = false,
  hasPlaceholder = true,
  children,
  priority = false,
  loading,
  sizes,
  style = {},
  /**  used to specify the maximum size of the image */
  maximumSize = formats[formats.length - 1],
  blurDataUrl,
  fill,
  ...rest
}) {
  const _sizes = sizes || "100vw";
  const sourceFile = typeof file === "string" ? { url: file } : file;

  let src = sourceFile?.url;

  const _priority = priority;
  const _asBackground =
    asBackground || (typeof file === "string" && !hasDimension(rest));

  const imageProps =
    typeof file !== "string" && !asBackground
      ? { width: sourceFile?.width, height: sourceFile?.height }
      : { width: rest?.width, height: rest?.height };

  const image = (
    <ImageWrapper
      alt={alt || ""}
      src={src}
      sizes={_sizes}
      file={file}
      fill={_asBackground}
      priority={_priority}
      maximumSize={maximumSize}
      loading={loading}
      blurDataUrl={blurDataUrl}
      hasPlaceholder={hasPlaceholder}
      {...imageProps}
      className={`overflow-clip ${
        asBackground
          ? "absolute -z-10 inset-0 w-full h-full"
          : `relative ${className}`
      }`}
      style={{
        verticalAlign: "middle",
        fontStyle: "italic",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        objectFit: "cover",
        backgroundImage:
          hasPlaceholder &&
          "radial-gradient(circle at 18.7% 37.8%, rgb(250, 250, 250) 0%, rgb(225, 234, 238) 90%)",
        ...style,
      }}
    />
  );

  if (_asBackground) {
    return (
      <Component
        className={`relative isolate overflow-clip ${className}`}
        {...rest}
      >
        {image} {children}
      </Component>
    );
  }

  return image;
}
